import React, { FC } from "react";
import { useTranslation } from "react-i18next";

export const UnauthorizedMessage: FC = () => {
  const { t } = useTranslation("dialogs");

  return (
    <>
      <span>{t("connectionProblem.sessionClosed")}</span>
      <span>{t("connectionProblem.refreshToContinue")}</span>
    </>
  );
};
